import React, { PropsWithChildren } from 'react'
import { Center } from '../../bases/Center'
import { NftState } from '../../commons/NotificationList/query.generated'
import { Absolute } from '../../bases/Absolute'
import { Clickable } from '../../bases/Clickable'

const cardStyle = {
  S: { width: 150, height: 206 },
  M: { width: 180, height: 246 },
  L: { width: 256, height: 351 },
}
const borderStyle = {
  S: { borderWidth: 1 },
  M: { borderWidth: 2 },
  L: { borderWidth: 2 },
}

export type CardSize = 'S' | 'M' | 'L'

export const CardFrame: React.FC<
  PropsWithChildren<{
    cardSize: CardSize
    state: NftState
    disabled?: boolean
    loading?: boolean
    onClick?: () => void
  }>
> = ({ children, cardSize, state, disabled, loading, onClick }) => {
  return (
    <Center className="relative rounded-xl" style={cardStyle[cardSize]}>
      <Center
        className="relative h-full w-full overflow-hidden rounded-xl border-[#805BE7] bg-black bg-gradient-to-b from-[rgba(0,0,0,0)] via-[rgba(0,0,0,0)] to-[#805BE760]"
        style={borderStyle[cardSize]}
      >
        {!!onClick ? (
          <Clickable onClick={onClick} className="h-full w-full">
            <a className="h-full w-full">{children}</a>
          </Clickable>
        ) : (
          children
        )}
      </Center>
      {!!loading || !!disabled || state !== NftState.InAkiverse ? (
        <Absolute className="pointer-events-none h-full w-full items-center justify-center rounded-xl bg-black bg-opacity-60">
          {(!!loading || ![NftState.InAkiverse, NftState.InWallet].includes(state)) && (
            <div className="h-10 w-10 animate-spin rounded-full border-[4px] border-neon-blue border-t-transparent border-opacity-70"></div>
          )}
        </Absolute>
      ) : null}
    </Center>
  )
}
